// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"estilos_breadcrumb__3kXlD"};